import axios from 'axios'
import { useAuthStore } from '../stores/auth'
import { useI18n } from '../composables/useI18n'
import { useLangStore } from '../stores/lang'

const apiClient = axios.create({
  baseURL: '',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
})

apiClient.interceptors.request.use((config) => {
  const auth = useAuthStore()
  const token = auth.getAuthHeader()
  if (token && config.headers) {
    config.headers.Authorization = token
  }
  const lang = useLangStore()
  config.headers['ui-lang'] = lang.lang
  return config
})

apiClient.interceptors.response.use(
  (response) => {
    const { code, msg } = response.data
    if (code === 0) return response
    if (code === 1001 || code === 1000) {
      const auth = useAuthStore()
      auth.logout()
      // 使用 history 模式的登录路径，并带上 UI_PATH 前缀
      const uiPath = (window as any).__UI_PATH__ || ''
      window.location.href = `${uiPath}/login`
      return Promise.reject(new Error(msg || 'Please login'))
    }
    if (code === 1003) {
      // 无权限：统一给出本地化的拒绝提示，避免暴露后端英文文案
      const { t } = useI18n()
      return Promise.reject(new Error(t('common.noPermission')))
    }
    return Promise.reject(new Error(msg || 'Request failed'))
  },
  (error) => Promise.reject(error),
)

export default apiClient
